export default {
  金安心: {
    fullname: '金安心醫院',
    divisions: [
      '婦產科',
      '小兒科',
      '醫學美容科',
      '乳房外科',
      '靜脈曲張門診',
    ],
  },
  金禾美: {
    fullname: '金禾美診所',
    divisions: [
      '婦產科',
      '小兒科',
      '醫學美容科',
    ],
  },
  urls: {
    logo: 'https://public.inncom.cloud/artemishosp/images/logo-eng.png',
    inncomLogo: 'https://public.inncom.cloud/inncom/images/logo.png',
    substitute: 'https://public.inncom.cloud/inncom/images/substitute.png',
  },
};
